import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
import ClipService from "../../../services/ClipService";
import GeneralService from "../../../services/GeneralService";
import BookmarkService from "../../../services/BookmarkService";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { Filter, X, DollarSign, MessageSquare, Plus, MoreHorizontal, AlertCircle, Heart, Share2, Bookmark, Lock, BookmarkCheck, Play, Check } from "lucide-react";
import {
  REDUX_LOCAL_STORE_KEY,
  USER_TYPES,
} from "../../../components/config/constants";
import Carousel from "react-elastic-carousel";
import Stories from "react-insta-stories";
import { Link, useHistory } from "react-router-dom";
import TipModal from "../Tip/TipModal";
import { FormatEmojii } from "../../../components/helper/FormatEmojii";
import ReportModal from "../../../components/common/commonModal/ReportModal.jsx";
import { getUserProfilePic } from "../../../components/helper/GeneralHelper";
import SingleCommentClip from "../../../components/common/commonModal/SingleCommentClip.jsx";
import AccountVerifyTick from "../../../components/common/AccountVerifyTick.jsx";
import DefaultAvatar from "../../../components/common/DefaultAvatar.jsx";
import EmojiList from "../../../components/common/EmojiList.jsx";
import InfiniteScroll from "react-infinite-scroll-component";

const Clip = () => {
  const { t } = useTranslation();
  const history = useHistory();

  let carouselRef = useRef(null);
  const width = window.innerWidth;
  const isMobile = width <= 512;

  const [state, setState] = useState({
    showFilters: false,
    clips: [],
    clipsUrl: [],
    currentClip: 0,
    showOption: false,
    isClipMuted: false,
    showModalTip: false,
    showModalReport: false,
    showModalComment: false,
    commentList: [],
    commentText: "",
    emojisList: JSON.parse(localStorage.getItem("emojis")),
    showAddReactionDesk: false,
    showAddReactionMobile: false,
    showAddReactionComment: false,
    isReply: false,
    targetReply: "",
    targetReplyId: "",
    typeApiClips: 3,
    categoryList: [],
    myCategory: [],
    isFree: false,
    isDiscounted: false,
    isDescending: true,
    currentPage: 1,
    maxPage: 0,
    isClipPaused: undefined,
    canScroll: true,
    totalComment: 0,
    commentPage: 0,
    commentLimit: 10,
  });

  // We use a ref to track latest state for event handlers
  const stateRef = useRef(state);
  stateRef.current = state;

  const muteAllVideos = useCallback(() => {
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      const videoElement = videoElements[i];
      videoElement.muted = stateRef.current.isClipMuted;
    }
  }, []);

  const controlReactionModal = useCallback((e) => {
    if (e.target.id === "openReactionModal" || e.target.id === "emojisModal") {
      // do nothing
    } else {
      setState((prev) => ({ ...prev, showAddReactionMobile: false }));
    }
  }, []);

  const handleClick = useCallback((e) => {
    const filter = document.getElementById("filterId");
    const filterCard = document.getElementById("filterIdCard");
    if (!filterCard.contains(e.target) && !filter.contains(e.target)) {
      setState((prev) => ({ ...prev, showFilters: false }));
    }
    if (e.target.className === "containter-button-mobile-pause") {
      setState((prev) => {
        const newPaused = !prev.isClipPaused;
        // Toggle pause on videos directly
        const videoElements = document.getElementsByTagName("video");
        for (let i = 0; i < videoElements.length; i++) {
          if (newPaused) {
            videoElements[i].pause();
          } else {
            videoElements[i].play();
          }
        }
        return { ...prev, isClipPaused: newPaused };
      });
    }
    controlReactionModal(e);
  }, [controlReactionModal]);

  const handleTouch = useCallback((e) => {
    if (e.target.className === "containter-button-mobile-pause") {
      setState((prev) => {
        const newPaused = !prev.isClipPaused;
        const videoElements = document.getElementsByTagName("video");
        for (let i = 0; i < videoElements.length; i++) {
          if (newPaused) {
            videoElements[i].pause();
          } else {
            videoElements[i].play();
          }
        }
        return { ...prev, isClipPaused: newPaused };
      });
    }
    controlReactionModal(e);
  }, [controlReactionModal]);

  const getMostViewedClip = useCallback(() => {
    const s = stateRef.current;
    let params = {
      limit: 20,
      page: s.currentPage,
      categoryIds: s.myCategory,
      orderBy: s.isDescending ? "DSC" : "ASC",
      ...(s.isFree === true && { free: true }),
      ...(s.isDiscounted === true && { onSale: true }),
    };
    ClipService.mostViewedClip({ ...params })
      .then((res) => {
        let fixedArrayClips = res.data.data[0].data.map((value) => ({
          url:
            value.clipMedia?.name === undefined
              ? value.clipMedia?.thumbnailUrl
              : value.clipMedia?.clipUrl,
          thumbNailImage: value.clipMedia?.thumbnailUrl,
          id: value.creatorDetails._id,
          clipId: value._id,
          type:
            (value.locked ? value.locked : false) === false ? "video" : null,
          creatorDetails: value.creatorDetails,
          description: value.description,
          bookmark: value.userBookmark ? true : false,
          emojiId: value.userReaction ? value.userReaction.uniCode : null,
          locked: value.locked ? value.locked : false,
          price: value.price,
        }));
        setState((prev) => ({
          ...prev,
          clips:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clips, ...res.data.data[0].data]
                : [...res.data.data[0].data]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clips.slice(1, prev.clips.length - 1),
                  ...res.data.data[0].data,
                  { blank: true },
                ]
              : [{ blank: true }, ...res.data.data[0].data, { blank: true }],
          clipsUrl:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clipsUrl, ...fixedArrayClips]
                : [...fixedArrayClips]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clipsUrl.slice(1, prev.clipsUrl.length - 1),
                  ...fixedArrayClips,
                  { blank: true },
                ]
              : [{ blank: true }, ...fixedArrayClips, { blank: true }],
        }));
      })
      .catch((err) => toast.error(err.message));
  }, []);

  const getRandomClip = useCallback(() => {
    const s = stateRef.current;
    let params = {
      limit: 20,
      page: s.currentPage,
      categoryIds: s.myCategory,
    };
    ClipService.randomClip({ ...params })
      .then((res) => {
        let fixedArrayClips = res.data.data[0].data.map((value) => ({
          url:
            value.clipMedia?.name === undefined
              ? value.clipMedia?.thumbnailUrl
              : value.clipMedia?.clipUrl,
          thumbNailImage: value.clipMedia?.thumbnailUrl,
          id: value.creatorDetails._id,
          clipId: value._id,
          type:
            (value.locked ? value.locked : false) === false ? "video" : null,
          creatorDetails: value.creatorDetails,
          description: value.description,
          bookmark: value.userBookmark ? true : false,
          emojiId: value.userReaction ? value.userReaction.uniCode : null,
          locked: value.locked ? value.locked : false,
          price: value.price,
        }));
        setState((prev) => ({
          ...prev,
          clips:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clips, ...res.data.data[0].data]
                : [...res.data.data[0].data]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clips.slice(1, prev.clips.length - 1),
                  ...res.data.data[0].data,
                  { blank: true },
                ]
              : [{ blank: true }, ...res.data.data[0].data, { blank: true }],
          clipsUrl:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clipsUrl, ...fixedArrayClips]
                : [...fixedArrayClips]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clipsUrl.slice(1, prev.clipsUrl.length - 1),
                  ...fixedArrayClips,
                  { blank: true },
                ]
              : [{ blank: true }, ...fixedArrayClips, { blank: true }],
        }));
      })
      .catch((err) => toast.error(err.message));
  }, []);

  const getNewestClip = useCallback(() => {
    const s = stateRef.current;
    let params = {
      limit: 20,
      page: s.currentPage,
      categoryIds: s.myCategory,
      ...(s.isFree === true && { free: true }),
      ...(s.isDiscounted === true && { onSale: true }),
      orderBy: s.isDescending ? "DSC" : "ASC",
    };
    ClipService.newClip({ ...params })
      .then((res) => {
        let fixedArrayClips = res.data.data[0].data.map((value) => ({
          url:
            value.clipMedia?.name === undefined
              ? value.clipMedia?.thumbnailUrl
              : value.clipMedia?.clipUrl,
          thumbNailImage: value.clipMedia?.thumbnailUrl,
          id: value.creatorDetails._id,
          clipId: value._id,
          type:
            (value.locked ? value.locked : false) === false ? "video" : null,
          creatorDetails: value.creatorDetails,
          description: value.description,
          bookmark: value.userBookmark ? true : false,
          emojiId: value.userReaction ? value.userReaction.uniCode : null,
          locked: value.locked ? value.locked : false,
          price: value.price,
        }));
        setState((prev) => ({
          ...prev,
          clips:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clips, ...res.data.data[0].data]
                : [...res.data.data[0].data]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clips.slice(1, prev.clips.length - 1),
                  ...res.data.data[0].data,
                  { blank: true },
                ]
              : [{ blank: true }, ...res.data.data[0].data, { blank: true }],
          clipsUrl:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clipsUrl, ...fixedArrayClips]
                : [...fixedArrayClips]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clipsUrl.slice(1, prev.clipsUrl.length - 1),
                  ...fixedArrayClips,
                  { blank: true },
                ]
              : [{ blank: true }, ...fixedArrayClips, { blank: true }],
        }));
      })
      .catch((err) => toast.error(err.message));
  }, []);

  const getMostSellClip = useCallback(() => {
    const s = stateRef.current;
    let params = {
      limit: 20,
      page: s.currentPage,
      categoryIds: s.myCategory,
      orderBy: s.isDescending ? "DSC" : "ASC",
      ...(s.isDiscounted === true && { onSale: true }),
    };
    ClipService.mostSellClip({ ...params })
      .then((res) => {
        let fixedArrayClips = res.data.data[0].data.map((value) => ({
          url:
            value.clipMedia?.name === undefined
              ? value.clipMedia?.thumbnailUrl
              : value.clipMedia?.clipUrl,
          thumbNailImage: value.clipMedia?.thumbnailUrl,
          id: value.creatorDetails._id,
          clipId: value._id,
          type:
            (value.locked ? value.locked : false) === false ? "video" : null,
          creatorDetails: value.creatorDetails,
          description: value.description,
          bookmark: value.userBookmark ? true : false,
          emojiId: value.userReaction ? value.userReaction.uniCode : null,
          locked: value.locked ? value.locked : false,
          price: value.price,
        }));
        setState((prev) => ({
          ...prev,
          clips:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clips, ...res.data.data[0].data]
                : [...res.data.data[0].data]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clips.slice(1, prev.clips.length - 1),
                  ...res.data.data[0].data,
                  { blank: true },
                ]
              : [{ blank: true }, ...res.data.data[0].data, { blank: true }],
          clipsUrl:
            1 > 0
              ? prev.currentPage > 1
                ? [...prev.clipsUrl, ...fixedArrayClips]
                : [...fixedArrayClips]
              : prev.currentPage > 1
              ? [
                  { blank: true },
                  ...prev.clipsUrl.slice(1, prev.clipsUrl.length - 1),
                  ...fixedArrayClips,
                  { blank: true },
                ]
              : [{ blank: true }, ...fixedArrayClips, { blank: true }],
        }));
      })
      .catch((err) => toast.error(err.message));
  }, []);

  const updateListOfClipByType = useCallback((typeApi) => {
    switch (typeApi) {
      case 0:
        getMostSellClip();
        break;
      case 1:
        getMostViewedClip();
        break;
      case 2:
        getNewestClip();
        break;
      case 3:
        getRandomClip();
        break;
      default:
        break;
    }
  }, [getMostSellClip, getMostViewedClip, getNewestClip, getRandomClip]);

  const updateListOfClip = useCallback((scroll) => {
    const s = stateRef.current;
    if (scroll) {
      updateListOfClipByType(s.typeApiClips);
    } else {
      setState((prev) => ({ ...prev, currentClip: 0, commentList: [], currentPage: 1 }));
      if (carouselRef && carouselRef.goTo) {
        carouselRef.goTo(0);
      }
      // Use setTimeout to ensure state is updated before calling API
      setTimeout(() => {
        updateListOfClipByType(stateRef.current.typeApiClips);
      }, 0);
    }
  }, [updateListOfClipByType]);

  const getAllCategory = () => {
    setState((prev) => ({ ...prev, loading: true }));
    GeneralService.getAllCategory()
      .then((res) => {
        setState((prev) => ({ ...prev, categoryList: res.data.data }));
      })
      .catch(() => {});
  };

  useEffect(() => {
    window.addEventListener("click", handleClick);
    window.addEventListener("touch", handleTouch);
    updateListOfClip();
    getAllCategory();

    return () => {
      window.removeEventListener("click", handleClick);
      window.removeEventListener("touch", handleTouch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMouseWheel = (e) => {
    const s = stateRef.current;
    if (s.canScroll) {
      setState((prev) => ({ ...prev, canScroll: false, isClipPaused: false, commentList: [] }));
      const delta = Math.max(-1, Math.min(1, e.deltaY));
      if (s.currentClip + delta >= s.clips.length) {
        history.push("/");
      } else {
        if (s.currentClip + delta >= 0) {
          carouselRef.goTo(s.currentClip + delta);
          setState((prev) => ({
            ...prev,
            isClipPaused: false,
            currentClip: prev.currentClip + delta,
          }));
          muteAllVideos();
        }
      }
      setTimeout(() => {
        setState((prev) => ({ ...prev, canScroll: true }));
      }, 750);
    }
  };

  const leaveLike = (clipId, index, indexReply) => {
    let params = {
      clipCommentId: clipId,
    };
    ClipService.leaveLikeComment({ ...params })
      .then(() => {
        toast.success(t("clip.commentVotedSuccessfully"));
        setState((prev) => {
          let commentList = [...prev.commentList];
          if (indexReply !== undefined) {
            commentList[index].replies[indexReply].totalCommentReactions =
              commentList[index].replies[indexReply].totalCommentReactions +
              (commentList[index].replies[indexReply].likeDetails ? -1 : +1);
            commentList[index].replies[indexReply].likeDetails
              ? (commentList[index].replies[indexReply].likeDetails = undefined)
              : (commentList[index].replies[indexReply].likeDetails = {
                  id: "id",
                });
          } else {
            commentList[index].totalCommentReactions =
              commentList[index].totalCommentReactions +
              (commentList[index].likeDetails ? -1 : +1);
            commentList[index].likeDetails
              ? (commentList[index].likeDetails = undefined)
              : (commentList[index].likeDetails = { id: "id" });
          }
          return { ...prev, commentList };
        });
      })
      .catch(() => {});
  };

  const goToStory = (storyIndex) => {
    setState((prev) => ({ ...prev, isClipPaused: false, commentList: [] }));
    if (storyIndex >= state.clips.length) {
      history.push("/");
    } else {
      carouselRef.goTo(storyIndex);
      setState((prev) => ({ ...prev, isClipPaused: false, currentClip: storyIndex }));
      muteAllVideos();
    }
  };

  const addRemoveBookMark = (index) => {
    let clipsUrl = [...state.clipsUrl];
    clipsUrl[index].bookmark = !clipsUrl[index].bookmark;
    setState((prev) => ({ ...prev, clipsUrl: clipsUrl }));

    let params = {
      type: "CLIP",
      contentId: state.clipsUrl[state.currentClip].clipId,
    };
    BookmarkService.addRemoveBookMarkOnPost({ ...params })
      .then((res) => {
        toast.success(
          t(
            res.data.message === "BookMark removed successfully."
              ? "clip.removedBookMark"
              : "clip.addedBookMark"
          )
        );
      })
      .catch(() => {});
  };

  const getCommentClip = () => {
    setState((prev) => ({ ...prev, commentPage: 0 }));
    let params = {
      clipId: state.clipsUrl[state.currentClip].clipId,
      limit: state.commentLimit,
    };
    ClipService.getCommentClip({ ...params })
      .then((value) => {
        setState((prev) => ({
          ...prev,
          commentList: value?.data?.data,
          totalComment: value.data?.totalCount,
        }));
      })
      .catch(() => {});
  };

  const loadMoreComment = () => {
    const nextPage = state.commentPage + 1;
    setState((prev) => ({ ...prev, commentPage: nextPage }));
    let params = {
      clipId: state.clipsUrl[state.currentClip].clipId,
      limit: state.commentLimit,
      page: nextPage,
    };
    ClipService.getCommentClip({ ...params })
      .then((value) => {
        setState((prev) => ({
          ...prev,
          commentList: [...prev.commentList, ...value.data.data],
          totalComment: value.data.totalCount,
        }));
      })
      .catch(() => {});
  };

  const addComment = () => {
    let params = {
      clipId: state.clipsUrl[state.currentClip].clipId,
      commentText: state.commentText,
      isReply: state.isReply,
      commentId: state.targetReplyId,
    };

    ClipService.addCommentClip({ ...params })
      .then(() => {
        setState((prev) => ({
          ...prev,
          commentText: "",
          isReply: false,
          targetReply: "",
          targetReplyId: "",
        }));
        getCommentClip();
      })
      .catch(() => {});
  };

  const addReactionClip = (clipId, emojiId, index, uniCode) => {
    let clipsUrl = [...state.clipsUrl];
    if (clipsUrl[index].emojiId === uniCode) {
      clipsUrl[index].emojiId = null;
    } else {
      clipsUrl[index].emojiId = uniCode;
    }
    setState((prev) => ({
      ...prev,
      showAddReactionMobile: false,
      showAddReactionDesk: false,
      clipsUrl: clipsUrl,
    }));
    let params = {
      clipId: clipId,
      emojiId: emojiId,
    };
    ClipService.addReactionClip({ ...params })
      .then(() => {})
      .catch(() => {});
  };

  const addClipView = (value) => {
    let params = {
      clipId: value.clipId,
    };
    ClipService.addClipView({ ...params })
      .then(() => {
        const nextClip = stateRef.current.currentClip + 1;
        setState((prev) => ({
          ...prev,
          isClipPaused: false,
          currentClip: nextClip,
        }));
        goToStory(nextClip);
      })
      .catch(() => {
        const nextClip = stateRef.current.currentClip + 1;
        setState((prev) => ({
          ...prev,
          isClipPaused: false,
          currentClip: nextClip,
        }));
        goToStory(nextClip);
      });
  };

  const updateCategory = (categoryId) => {
    setState((prev) => {
      const newMyCategory = prev.myCategory.includes(categoryId)
        ? prev.myCategory.filter((id) => id !== categoryId)
        : [...prev.myCategory, categoryId];
      return { ...prev, myCategory: newMyCategory };
    });
    // Need to call updateListOfClip after state update
    setTimeout(() => updateListOfClip(), 0);
  };

  const closeCommentModal = () => {
    setState((prev) => ({
      ...prev,
      showModalComment: false,
      commentText: "",
      isReply: false,
      targetReply: "",
      targetReplyId: "",
    }));
  };

  const renderWidth = window.innerWidth;
  const renderIsMobile = renderWidth <= 512;

  return (
    <Fragment>
      <div className="emojis-fix-clip finalContainer main-content-clip right-chat-active pad-fix-clip flex-paginator mobile-clips">
        <div
          id={`filterIdCard`}
          className={`${
            state.showFilters === false && "display-none"
          } div-filter-clip fc-view filter-clip input-search-clip nobar`}
        >
          <div
            style={{ marginBottom: "20px" }}
            className="mt-top32px flex-paginator"
          >
            <span className="filter-text w-50 align-center">
              {t("common.filter")}
            </span>
            <span
              onClick={() => setState((prev) => ({ ...prev, showFilters: false }))}
              className="x-icon-filter w-50 align-center"
            >
              <X size={16} />
            </span>
          </div>
          <form action="#">
            <span className="mainlabel text-filter-clip-second-bar">
              {t("clip.sortBy")}
            </span>
            <div className="mb-6px mb-2 d-flex align-items-center">
              <input
                type="radio"
                className="cursor-pointer active-checkbox-clip"
                id="Black"
                name="payment-method"
                checked={!state.isDescending}
                onClick={() => {
                  setState((prev) => ({ ...prev, isDescending: false }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />

              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("common.ascending")}
              </label>
            </div>
            <div className="mb-6px mb-2 d-flex align-items-center">
              <input
                type="radio"
                className="cursor-pointer"
                id="Black"
                name="payment-method"
                checked={state.isDescending}
                onClick={() => {
                  setState((prev) => ({ ...prev, isDescending: true }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />
              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("common.descending")}
              </label>
            </div>
          </form>

          <form style={{ marginTop: "24px" }} action="#">
            <span className="mainlabel text-filter-clip-second-bar">
              {t("clip.clips")}
            </span>
            <div className="mb-6px mb-2 d-flex align-items-center">
              {state.typeApiClips === 0 && (
                <div
                  style={{
                    position: "relative",
                    width: "0px",
                    height: "0px",
                  }}
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      typeApiClips: state.typeApiClips === 0 ? 3 : 0,
                      isFree: false,
                    }));
                    setTimeout(() => updateListOfClip(), 0);
                  }}
                >
                  <Check size={12} className="checkbox-check-icon" />
                </div>
              )}
              <input
                type="checkbox"
                className="cursor-pointer"
                id="Black"
                name="payment-method"
                checked={state.typeApiClips === 0 ? true : false}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    typeApiClips: state.typeApiClips === 0 ? 3 : 0,
                    isFree: false,
                  }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />

              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("clip.bestSellers")}
              </label>
            </div>
            <div className="mb-6px mb-2 d-flex align-items-center">
              {state.typeApiClips === 1 && (
                <div
                  style={{
                    position: "relative",
                    width: "0px",
                    height: "0px",
                  }}
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      typeApiClips: state.typeApiClips === 1 ? 3 : 1,
                    }));
                    setTimeout(() => updateListOfClip(), 0);
                  }}
                >
                  <Check size={12} className="checkbox-check-icon" />
                </div>
              )}
              <input
                type="checkbox"
                className="cursor-pointer"
                id="Black"
                name="payment-method"
                checked={state.typeApiClips === 1 ? true : false}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    typeApiClips: state.typeApiClips === 1 ? 3 : 1,
                  }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />
              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("clip.moreSeen")}
              </label>
            </div>
            <div className="mb-6px mb-2 d-flex align-items-center">
              {state.typeApiClips === 2 && (
                <div
                  style={{
                    position: "relative",
                    width: "0px",
                    height: "0px",
                  }}
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      typeApiClips: state.typeApiClips === 2 ? 3 : 2,
                    }));
                    setTimeout(() => updateListOfClip(), 0);
                  }}
                >
                  <Check size={12} className="checkbox-check-icon" />
                </div>
              )}
              <input
                type="checkbox"
                className="cursor-pointer"
                id="Black"
                name="payment-method"
                checked={state.typeApiClips === 2 ? true : false}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    typeApiClips: state.typeApiClips === 2 ? 3 : 2,
                  }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />
              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("clip.new")}
              </label>
            </div>
          </form>

          <form style={{ marginTop: "24px" }} action="#">
            <span className="mainlabel text-filter-clip-second-bar">
              {t("clip.byPrice")}
            </span>
            <div className="mb-6px mb-2 d-flex align-items-center">
              {state.isDiscounted && (
                <div
                  style={{
                    position: "relative",
                    width: "0px",
                    height: "0px",
                  }}
                  onClick={() => {
                    setState((prev) => ({ ...prev, isDiscounted: !prev.isDiscounted }));
                    setTimeout(() => updateListOfClip(), 0);
                  }}
                >
                  <Check size={12} className="checkbox-check-icon" />
                </div>
              )}
              <input
                type="checkbox"
                className="cursor-pointer"
                id="Black"
                name="payment-method"
                checked={state.isDiscounted}
                onClick={() => {
                  setState((prev) => ({ ...prev, isDiscounted: !prev.isDiscounted }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />

              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("clip.discounted")}
              </label>
            </div>
            <div className="mb-6px mb-2 d-flex align-items-center">
              {state.isFree && (
                <div
                  style={{
                    position: "relative",
                    width: "0px",
                    height: "0px",
                  }}
                  onClick={() => {
                    setState((prev) => ({ ...prev, isFree: !prev.isFree }));
                    setTimeout(() => updateListOfClip(), 0);
                  }}
                >
                  <Check size={12} className="checkbox-check-icon" />
                </div>
              )}
              <input
                type="checkbox"
                className="cursor-pointer"
                id="Black"
                name="payment-method"
                disabled={state.typeApiClips === 0 ? true : false}
                checked={state.isFree}
                onClick={() => {
                  setState((prev) => ({ ...prev, isFree: !prev.isFree }));
                  setTimeout(() => updateListOfClip(), 0);
                }}
              />
              <label
                className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
              >
                {t("clip.free")}
              </label>
            </div>
          </form>

          <form style={{ marginTop: "24px" }} action="#">
            <span className="mainlabel text-filter-clip-second-bar">
              {t("clip.byCategory")}
            </span>
            {state.categoryList.map((value, index) => (
              <div className="mb-6px mb-2 d-flex align-items-center">
                <div
                  style={{
                    position: "relative",
                    width: "0px",
                    height: "0px",
                  }}
                >
                  <Check
                    size={12}
                    onClick={() => updateCategory(value._id)}
                    className="checkbox-check-icon"
                  />
                </div>
                <input
                  onChange={() => updateCategory(value._id)}
                  type="checkbox"
                  checked={state.myCategory.includes(value._id)}
                  className="cursor-pointer"
                  id="Black"
                  name="payment-method"
                />
                <label
                  className={`payment-label  fw-600 text-black ms-2 bookmarkText`}
                >
                  {t(`category.${value.categoryName}`)}
                </label>
              </div>
            ))}
          </form>
        </div>
        <>
          {isMobile === false ? (
            <div
              id="filterId"
              className={`${
                state.showFilters && "display-none"
              } div-filter-clip absolute-center nobar`}
            >
              <Button
                onClick={() => setState((prev) => ({ ...prev, showFilters: true }))}
                className="width99px wallet-schedule-button fc-view padding-top-4rem"
              >
                {t("common.filter")}
                <div style={{ width: "2px" }}></div> <Filter size={16} />
              </Button>
            </div>
          ) : (
            <Button
              id="filterId"
              onClick={() => setState((prev) => ({ ...prev, showFilters: true }))}
              className={`${
                state.showFilters && "display-none"
              } width99px wallet-schedule-button fc-view z-index-fix-mobile-clip`}
              style={{ width: "100px", marginTop: "18px" }}
            >
              <div style={{ width: "2px" }}></div> <Filter size={16} />
            </Button>
          )}
        </>
        <div onWheel={handleMouseWheel} className={`container-clip`}>
          <Carousel
            verticalMode={true}
            ref={(ref) => (carouselRef = ref)}
            enableSwipe={true}
            enableMouseSwipe={true}
            showArrows={false}
            pagination={false}
            breakPoints={[
              {
                width: 0,
                itemsToShow: isMobile ? 1 : 1,
              },
            ]}
            onChange={(event) =>
              setState((prev) => {
                const newState = {
                  ...prev,
                  showOption: false,
                  currentClip: event.index,
                };
                // Schedule side effects
                setTimeout(() => {
                  muteAllVideos();
                  if (
                    event.index >
                    stateRef.current.currentPage * 20 - 7
                  ) {
                    setState((p) => ({
                      ...p,
                      currentPage: p.currentPage + 1,
                    }));
                    setTimeout(() => updateListOfClip(true), 0);
                  }
                }, 0);
                return newState;
              })
            }
          >
            {state.clipsUrl.map((value, index) => (
              <div>
                {index === state.currentClip ? (
                  <div className="clip-card-current flex-paginator">
                    {renderIsMobile && state.isClipPaused && (
                      <div className="containter-button-mobile-pause">
                        <div className="pause-button-clip">
                          <div className="pause-internal-button-clip">
                            <Play
                              size={36}
                              style={{
                                color: "#FFFFFF",
                                paddingLeft: "4px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <span className="relative">
                      <span className={`clip-creator-icon`}>
                        <div className={`flex-paginator`}>
                          <Link
                            to={`/${value.creatorDetails.userName}`}
                            className="text-decoration-none text-black flex-paginator"
                          >
                            <span
                              style={{ width: "32px", height: "32px" }}
                              className="picture-story"
                            >
                              <DefaultAvatar
                                className={`story-box-container hover`}
                                width={"32px"}
                                height={"32px"}
                                userName={value.creatorDetails.name}
                                id={value.creatorDetails._id}
                              >
                                {value.creatorDetails.profilePicture ? (
                                  <Image
                                    width={32}
                                    height={32}
                                    title={value.creatorDetails.name}
                                    alt={value.creatorDetails.name}
                                    className={`story-box-container hover`}
                                    src={getUserProfilePic(
                                      value.creatorDetails._id,
                                      value.creatorDetails.profilePicture
                                    )}
                                  ></Image>
                                ) : null}
                              </DefaultAvatar>
                            </span>
                            <span className="story-creators-name">
                              {value.creatorDetails.name}{" "}
                              {value?.creatorDetails?.isCreatorVerified ? (
                                <span
                                  style={{
                                    marginLeft: "2px",
                                    verticalAlign: "text-bottom",
                                  }}
                                >
                                  <AccountVerifyTick width="15px"></AccountVerifyTick>
                                </span>
                              ) : null}
                            </span>
                          </Link>
                        </div>
                        {value.locked ? null : (
                          <div className="description-clip">
                            {value.description}
                          </div>
                        )}
                        {isMobile && (
                          <div className={`flex-paginator icons-clip-mobile`}>
                            {!value.locked && (
                              <div className="icon-for-clip-mobile">
                                {value.emojiId === null ? (
                                  <button
                                    onBlur={() => {
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionMobile: false,
                                      }));
                                    }}
                                    onClick={() =>
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionMobile:
                                          !prev.showAddReactionMobile,
                                      }))
                                    }
                                    className="fix-button-like"
                                  >
                                    <Heart
                                      size={16}
                                      color="white"
                                      id="openReactionModal"
                                    />
                                    <EmojiList
                                      show={state.showAddReactionMobile}
                                      style={{ bottom: "10px" }}
                                      emojisList={state.emojisList}
                                      onClickOutside={() => {
                                        setState((prev) => ({
                                          ...prev,
                                          showAddReactionMobile: false,
                                        }));
                                      }}
                                      onAddOrRemoveReaction={(
                                        emojiId,
                                        emojiUnicode
                                      ) => {
                                        addReactionClip(
                                          value.clipId,
                                          emojiId,
                                          index,
                                          emojiUnicode
                                        );
                                      }}
                                    />
                                  </button>
                                ) : (
                                  <button
                                    onBlur={() => {
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionMobile: false,
                                      }));
                                    }}
                                    onClick={() =>
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionMobile:
                                          !prev.showAddReactionMobile,
                                      }))
                                    }
                                    className="fix-button-like"
                                  >
                                    <span className="font-lg pointer em font-size-18px">
                                      {FormatEmojii(value.emojiId)}
                                      <EmojiList
                                        show={state.showAddReactionMobile}
                                        style={{ bottom: "10px" }}
                                        emojisList={state.emojisList}
                                        onClickOutside={() => {
                                          setState((prev) => ({
                                            ...prev,
                                            showAddReactionMobile: false,
                                          }));
                                        }}
                                        onAddOrRemoveReaction={(
                                          emojiId,
                                          emojiUnicode
                                        ) => {
                                          addReactionClip(
                                            value.clipId,
                                            emojiId,
                                            index,
                                            emojiUnicode
                                          );
                                        }}
                                      />
                                    </span>
                                  </button>
                                )}
                              </div>
                            )}
                            {!value.locked && (
                              <div
                                onClick={() => {
                                  getCommentClip();
                                  setState((prev) => ({ ...prev, showModalComment: true }));
                                }}
                                className="icon-for-clip-mobile"
                              >
                                <MessageSquare size={16} />
                              </div>
                            )}
                            <div
                              onClick={() => addRemoveBookMark(index)}
                              className="icon-for-clip-mobile"
                            >
                              {value.bookmark ? (
                                <BookmarkCheck size={16} />
                              ) : (
                                <Bookmark size={16} />
                              )}
                            </div>
                            <div
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `${new URL(window.location.href).protocol}//${new URL(window.location.href).host}/single-clip?clipId=${value.clipId}`
                                );
                                toast.success(t("clip.copiedToClipboard"));
                              }}
                              className="icon-for-clip-mobile"
                            >
                              <Share2 size={16} />
                            </div>
                            {
                              <button
                                onBlur={() => setState((prev) => ({ ...prev, showOption: false }))}
                                onClick={() => setState((prev) => ({ ...prev, showOption: !prev.showOption }))}
                                className="fix-button-like icon-for-clip-mobile"
                              >
                                <div className="icon-for-clip-mobile">
                                  <MoreHorizontal size={16} style={{ color: "#FFFFFF" }} />
                                  {state.showOption && (
                                    <div className="option-clip-div">
                                      <div onClick={() => setState((prev) => ({ ...prev, showModalReport: true }))}>
                                        <AlertCircle size={16} style={{ position: "relative", top: "-2px" }} />{" "}
                                        {t("clip.report")}
                                      </div>
                                      <div onClick={() => setState((prev) => ({ ...prev, showModalTip: true }))}>
                                        <DollarSign size={16} style={{ position: "relative", top: "-2px" }} />{" "}
                                        {t("stories.tip")}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </button>
                            }
                          </div>
                        )}
                      </span>
                    </span>
                    <span
                      className={`disable-reload-clip test-extreme-div-height story-style ${
                        value.locked && "blocked-clip "
                      }`}
                    >
                      <Stories
                        isPaused={state.isClipPaused === true ? true : undefined}
                        preventDefault={true}
                        storyContainerStyles={{ overflow: "hidden" }}
                        progressContainerStyles={{ display: "none" }}
                        stories={[value]}
                        defaultInterval={10000}
                        width={isMobile ? "100vw" : "calc(86.6666666vh * 0.560897 )"}
                        height={isMobile ? "calc(100%-32px)" : "86.6666666vh"}
                        loop={false}
                        onAllStoriesEnd={() => {
                          addClipView(value);
                        }}
                        onNext={(event) => {
                          event.preventDefault();
                        }}
                      />
                      {value.locked !== true && (
                        <div
                          className={`${
                            renderIsMobile
                              ? "containter-button-mobile-pause"
                              : "containter-button-mobile-pause"
                          }`}
                          name="pause-button"
                        >
                          {renderIsMobile === false && state.isClipPaused && (
                            <div className="containter-button-mobile-pause">
                              <div className="pause-button-mobile">
                                <div className="pause-internal-button-clip">
                                  <Play
                                    size={36}
                                    style={{
                                      color: "#FFFFFF",
                                      paddingLeft: "4px",
                                      zIndex: 9999999,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </span>
                    {value.locked && (
                      <div
                        className={`clip-card-background hover ${isMobile ? "blocked-clip" : ""}`}
                        style={{
                          position: "absolute",
                          zIndex: 999,
                          backgroundSize: "cover",
                          backgroundImage: isMobile ? `url('${value.thumbNailImage}')` : "",
                        }}
                      >
                        <div className="d-flex justify-content-center align-items-center">
                          <div className={`hover w-auto ${isMobile ? "zIndex9999" : ""}`}>
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="clip-lock-box">
                                <Lock size={16} />
                              </div>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="clip-is-locked">{t("clip.lockedContent")}</div>
                            </div>
                            <div>
                              <Link
                                to={{
                                  pathname: "/payment",
                                  state: {
                                    creatorDetails: value.creatorDetails,
                                    creatorPicture: getUserProfilePic(
                                      value.creatorDetails?._id,
                                      value.creatorDetails?.profilePicture,
                                      true,
                                      "0% 0% / cover no-repeat"
                                    ),
                                    price: value.price,
                                    typeOfPayment: 2,
                                    clipId: value.clipId,
                                  },
                                }}
                              >
                                <button className="width-button-buy-clip p-0 btn p-2 lh-24 w125 ms-1  d-inline-block rounded-xl creatorButton border-red detailTitle fw-700 text-white">
                                  {t("clip.unlockContentFor$")}
                                  {`${value.price}`}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {isMobile === false ? (
                      <div className="container-button-clip">
                        <div className="fix-containter-clip">
                          {JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData.userType === USER_TYPES.CREATOR && (
                            <div className="add-clip-button" onClick={() => history.push("/upload-clip")}>
                              <Plus size={16} />
                            </div>
                          )}
                          <div className="clip-option-button">
                            {!value.locked && (
                              <div className="icon-for-clip">
                                {value.emojiId === null ? (
                                  <button
                                    onBlur={() => setState((prev) => ({ ...prev, showAddReactionDesk: false }))}
                                    onClick={() => setState((prev) => ({ ...prev, showAddReactionDesk: !prev.showAddReactionDesk }))}
                                    className="fix-button-like"
                                  >
                                    <Heart size={16} />
                                    <EmojiList
                                      show={state.showAddReactionDesk}
                                      style={{ left: "-200px" }}
                                      emojisList={state.emojisList}
                                      onClickOutside={() => setState((prev) => ({ ...prev, showAddReactionDesk: false }))}
                                      onAddOrRemoveReaction={(emojiId, emojiUnicode) => addReactionClip(value.clipId, emojiId, index, emojiUnicode)}
                                    />
                                  </button>
                                ) : (
                                  <button
                                    onBlur={() => setState((prev) => ({ ...prev, showAddReactionDesk: false }))}
                                    onClick={() => setState((prev) => ({ ...prev, showAddReactionDesk: !prev.showAddReactionDesk }))}
                                    className="fix-button-like"
                                  >
                                    <span
                                      onClick={() => setState((prev) => ({ ...prev, showAddReactionDesk: !prev.showAddReactionDesk }))}
                                      className="font-lg pointer em font-size-18px"
                                    >
                                      {FormatEmojii(value.emojiId)}
                                      <EmojiList
                                        show={state.showAddReactionDesk}
                                        style={{ left: "-200px" }}
                                        emojisList={state.emojisList}
                                        onClickOutside={() => setState((prev) => ({ ...prev, showAddReactionDesk: false }))}
                                        onAddOrRemoveReaction={(emojiId, emojiUnicode) => addReactionClip(value.clipId, emojiId, index, emojiUnicode)}
                                      />
                                    </span>
                                  </button>
                                )}
                              </div>
                            )}
                            {!value.locked && (
                              <div
                                onClick={() => {
                                  setState((prev) => ({ ...prev, showModalComment: true }));
                                  getCommentClip();
                                }}
                                className="icon-for-clip"
                              >
                                <MessageSquare size={16} />
                              </div>
                            )}
                            <div onClick={() => addRemoveBookMark(index)} className="icon-for-clip">
                              {value.bookmark ? <BookmarkCheck size={16} /> : <Bookmark size={16} />}
                            </div>
                            <div
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `${new URL(window.location.href).protocol}//${new URL(window.location.href).host}/single-clip?clipId=${value.clipId}`
                                );
                                toast.success(t("clip.copiedToClipboard"));
                              }}
                              className="icon-for-clip"
                            >
                              <Share2 size={16} />
                            </div>
                            {
                              <button
                                onBlur={() => setState((prev) => ({ ...prev, showOption: false }))}
                                onClick={() => setState((prev) => ({ ...prev, showOption: !prev.showOption }))}
                                className="fix-button-like"
                              >
                                <div className="internal-3point">
                                  <MoreHorizontal size={16} />
                                  {state.showOption && (
                                    <div className="option-clip-div-desk">
                                      <div
                                        onClick={() => setState((prev) => ({ ...prev, showModalReport: true }))}
                                        style={{ alignItems: "center", display: "inline-flex", justifyContent: "space-evenly" }}
                                      >
                                        <AlertCircle size={16} style={{ position: "relative", top: "-2px" }} />{" "}
                                        {t("clip.report")}
                                      </div>
                                      <div
                                        onClick={() => setState((prev) => ({ ...prev, showModalTip: true }))}
                                        style={{ alignItems: "center", display: "inline-flex", justifyContent: "space-evenly" }}
                                      >
                                        <DollarSign size={16} style={{ position: "relative", top: "-2px" }} />{" "}
                                        {t("stories.tip")}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData.userType === USER_TYPES.CREATOR && (
                          <span className="relative">
                            <div onClick={() => history.push("/upload-clip")} className="mobile-add-clip">
                              <Plus size={16} />
                            </div>
                          </span>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <>
                    {value.blank === true ? (
                      <div className={`clip-card-blank`}></div>
                    ) : (
                      <div
                        onClick={() => {
                          setState((prev) => ({ ...prev, isClipPaused: prev.isClipPaused }));
                          goToStory(index);
                        }}
                        className={`clip-card-background hover blocked-clip`}
                        style={{
                          backgroundSize: "cover",
                          backgroundImage: `url('${value.thumbNailImage}')`,
                        }}
                      >
                        {value.locked ? (
                          <>
                            <div
                              className={`clip-card-background hover ${isMobile ? "blocked-clip" : ""}`}
                              style={{
                                position: "absolute",
                                zIndex: 999,
                                backgroundSize: "cover",
                                backgroundImage: isMobile ? `url('${value.thumbNailImage}')` : "",
                              }}
                            >
                              <div className="d-flex justify-content-center align-items-center">
                                <div className={`hover w-auto ${isMobile ? "zIndex9999" : ""}`}>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <div className="clip-lock-box">
                                      <Lock size={16} />
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <div className="clip-is-locked">{t("clip.lockedContent")}</div>
                                  </div>
                                  <div>
                                    <Link
                                      to={{
                                        pathname: "/payment",
                                        state: {
                                          creatorDetails: value.creatorDetails,
                                          creatorPicture: getUserProfilePic(
                                            value.creatorDetails?._id,
                                            value.creatorDetails?.profilePicture,
                                            true,
                                            "0% 0% / cover no-repeat"
                                          ),
                                          price: value.price,
                                          typeOfPayment: 2,
                                          clipId: value.clipId,
                                        },
                                      }}
                                    >
                                      <button className="width-button-buy-clip p-0 btn p-2 lh-24 w125 ms-1  d-inline-block rounded-xl creatorButton border-red detailTitle fw-700 text-white">
                                        {t("clip.unlockContentFor$")}
                                        {`${value.price}`}
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="story-box-extra hover" style={{ zIndex: 2 }}>
                            <div className="story-box story-box-clip">
                              <DefaultAvatar
                                className={`story-box-container hover`}
                                width={"52px"}
                                height={"52px"}
                                fontSize={"20px"}
                                id={value.creatorDetails._id}
                                userName={value.creatorDetails.name}
                              >
                                {value.creatorDetails.profilePicture ? (
                                  <Image
                                    width={52}
                                    height={52}
                                    title={value.creatorDetails.name}
                                    alt={value.creatorDetails.name}
                                    className={`story-box-container hover`}
                                    src={getUserProfilePic(value.creatorDetails._id, value.creatorDetails.profilePicture)}
                                  ></Image>
                                ) : null}
                              </DefaultAvatar>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
      {state.showModalTip && (
        <TipModal
          userName={state.clipsUrl[state.currentClip].creatorDetails.userName}
          show={state.showModalTip}
          onHide={() => setState((prev) => ({ ...prev, showModalTip: false }))}
          id={state.clipsUrl[state.currentClip].id}
          objId={state.clipsUrl[state.currentClip].clipId}
          tipArea={"CLIPS"}
        />
      )}
      {state.showModalReport && (
        <ReportModal
          type={4}
          reported={state.clipsUrl[state.currentClip].creatorDetails._id}
          id={state.clipsUrl[state.currentClip].clipId}
          show={state.showModalReport}
          onHide={() => setState((prev) => ({ ...prev, showModalReport: false }))}
        />
      )}
      <Modal
        show={state.showModalComment}
        onHide={() => closeCommentModal()}
        keyboard={false}
        centered
        className="margin-modal-comment-clip"
      >
        <Modal.Header>
          <span className="filter-text">{t("clip.commentsOnClips")} </span>
          <span className="filter-text hover" onClick={() => closeCommentModal()}>
            x
          </span>
        </Modal.Header>
        <Modal.Body>
          <InfiniteScroll
            dataLength={state.commentList.length}
            next={() => loadMoreComment()}
            hasMore={state.totalComment > state.commentList.length ? true : false}
            scrollableTarget="commentsClipScroll"
            className="right-scroll-bar h-100-perc"
          ></InfiniteScroll>
          <div id="commentsClipScroll" className="list-comment-clip nobar">
            {state.commentList.map((value, index) => (
              <div>
                <SingleCommentClip
                  isCreatorVerified={value.userDetails?.isCreatorVerified}
                  name={value.userDetails?.name}
                  commentText={value.commentText}
                  createdAt={value.createdAt}
                  totalCommentReactions={value.totalCommentReactions}
                  _id={value.userDetails?._id}
                  index={index}
                  profilePicture={value.userDetails?.profilePicture}
                  showReply={true}
                  replyAction={() =>
                    setState((prev) => ({
                      ...prev,
                      targetReplyId: value._id,
                      targetReply: value.userDetails.userName,
                      commentText: "@" + value.userDetails.userName + " ",
                      isReply: true,
                    }))
                  }
                  showAddReactionComment={state.showAddReactionComment}
                  leaveLike={() => leaveLike(value._id, index)}
                ></SingleCommentClip>
                {value?.replies && (
                  <>
                    {value?.replies.map((valueReply, indexReply) => (
                      <div className="ml-24px">
                        <SingleCommentClip
                          isCreatorVerified={valueReply.userDetails?.isCreatorVerified}
                          name={valueReply.userDetails?.name}
                          commentText={valueReply.commentText}
                          createdAt={valueReply.createdAt}
                          totalCommentReactions={valueReply.totalCommentReactions}
                          _id={valueReply.userDetails?._id}
                          index={indexReply}
                          profilePicture={valueReply.userDetails?.profilePicture}
                          showReply={false}
                          showAddReactionComment={state.showAddReactionComment}
                          leaveLike={() => leaveLike(valueReply._id, index, indexReply)}
                        ></SingleCommentClip>
                      </div>
                    ))}
                  </>
                )}
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "space-between" }}>
          <div className="d-flex" style={{ width: "100%" }}>
            <span style={{ paddingRight: "8px" }}>
              <DefaultAvatar
                width={"32px"}
                height={"32px"}
                id={JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData._id}
                userName={JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData.name}
              >
                {JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData.profilePicture ? (
                  <Image
                    src={getUserProfilePic(
                      JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData._id,
                      JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY)).authentication.userData.profilePicture
                    )}
                    className="border-radius-40"
                    width={32}
                    height={32}
                  ></Image>
                ) : null}
              </DefaultAvatar>
            </span>
            {state.isReply && (
              <div className="reply-clip-confirm">
                <span className="flex-paginator">
                  <div style={{ width: "100%" }}>
                    {t("clip.replyTo")} {state.targetReply}
                  </div>
                  <div
                    onClick={() =>
                      setState((prev) => ({
                        ...prev,
                        commentText: "",
                        isReply: false,
                        targetReply: "",
                        targetReplyId: "",
                      }))
                    }
                    style={{ paddingRight: "10px" }}
                  >
                    x
                  </div>
                </span>
              </div>
            )}
            <input
              style={{ width: "100%" }}
              placeholder={t("clip.writeYourComment")}
              className="clip-comment-input"
              value={state.commentText}
              onChange={(value) => setState((prev) => ({ ...prev, commentText: value.target.value }))}
            ></input>
          </div>
          <div className="d-flex" style={{ width: "100%", justifyContent: "right" }}>
            <Button onClick={() => closeCommentModal()} className="cancel-button-clip">
              {t("common.cancel")}
            </Button>
            <Button
              onClick={() => {
                if (state.commentText === "" || state.commentText === null || state.commentText === undefined) {
                  toast.error(t("clip.needMessage"));
                } else {
                  addComment();
                }
              }}
              className="cancel-button-clip send-button-clip"
            >
              {t("common.send")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default Clip;
